import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bc60317"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "heading"
}
const _hoisted_3 = {
  key: 1,
  class: "heading"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "col-md-4 col-sm-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "companyName",
  class: "form-label"
}, "Name der Einrichtung", -1))
const _hoisted_10 = { class: "mb-3 row" }
const _hoisted_11 = { class: "col-md-4 col-sm-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "street",
  class: "form-label"
}, "Straße", -1))
const _hoisted_13 = { class: "col-md-4 col-sm-12" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "street_no",
  class: "form-label"
}, "Haus Nummer ", -1))
const _hoisted_15 = { class: "mb-3 row" }
const _hoisted_16 = { class: "col-md-8 col-sm-12" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "address_addition",
  class: "form-label"
}, "Adresszusatz", -1))
const _hoisted_18 = { class: "mb-3 row" }
const _hoisted_19 = { class: "col-md-4 col-sm-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "postal_code",
  class: "form-label"
}, "Postleitzahl", -1))
const _hoisted_21 = { class: "col-md-4 col-sm-12" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-label"
}, "Stadt", -1))
const _hoisted_23 = { class: "mb-3 row mt-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4" }, "Kontaktperson:", -1))
const _hoisted_25 = { class: "col-md-4 col-sm-12" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "first_name",
  class: "form-label"
}, "Vorname", -1))
const _hoisted_27 = { class: "col-md-4 col-sm-12" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "last_name",
  class: "form-label"
}, "Nachname", -1))
const _hoisted_29 = { class: "mb-3 row" }
const _hoisted_30 = { class: "col-md-4 col-sm-12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "form-label"
}, "Telefon", -1))
const _hoisted_32 = { class: "col-md-4 col-sm-12" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "E-Mail", -1))
const _hoisted_34 = { class: "mb-3 row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4" }, "Abweichende Rechnungsadresse:", -1))
const _hoisted_36 = { class: "col-md-4 col-sm-12" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "companyName",
  class: "form-label"
}, "Firma", -1))
const _hoisted_38 = { class: "mb-3 row" }
const _hoisted_39 = { class: "col-md-4 col-sm-12" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "street",
  class: "form-label"
}, "Straße", -1))
const _hoisted_41 = { class: "col-md-4 col-sm-12" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "street_no",
  class: "form-label"
}, "Haus Nummer ", -1))
const _hoisted_43 = { class: "mb-3 row" }
const _hoisted_44 = { class: "col-md-8 col-sm-12" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "address_addition",
  class: "form-label"
}, "Adresszusatz", -1))
const _hoisted_46 = { class: "mb-3 row" }
const _hoisted_47 = { class: "col-md-4 col-sm-12" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "postal_code",
  class: "form-label"
}, "Postleitzahl", -1))
const _hoisted_49 = { class: "col-md-4 col-sm-12" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-label"
}, "Stadt", -1))
const _hoisted_51 = { class: "mb-3 row mt-5" }
const _hoisted_52 = {
  key: 0,
  class: "col-md-8 col-sm-12 d-flex"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "agb",
  class: "me-2",
  required: ""
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "agb" }, "Ich habe die Allgemeinen Geschäftsbedingungen gelesen", -1))
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { class: "col-md-8 col-sm-12 d-flex" }
const _hoisted_57 = {
  key: 0,
  class: "button grey"
}
const _hoisted_58 = {
  key: 0,
  type: "submit",
  class: "button ms-auto"
}
const _hoisted_59 = {
  key: 1,
  type: "submit",
  class: "button ms-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hasOrganisation)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Einrichtung anlegen"))
      : _createCommentVNode("", true),
    (_ctx.hasOrganisation)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Einrichtung Bearbeiten"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.company.name) = $event)),
                  class: "form-control",
                  id: "companyName",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.company.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.company.street) = $event)),
                  class: "form-control",
                  id: "street",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.company.street]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.company.streetNo) = $event)),
                  class: "form-control",
                  id: "street_no",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.company.streetNo]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.company.addressAddition) = $event)),
                  class: "form-control",
                  id: "address_addition"
                }, null, 512), [
                  [_vModelText, _ctx.data.company.addressAddition]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  type: "postal_code",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.company.postalCode) = $event)),
                  class: "form-control",
                  id: "postal_code",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.company.postalCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data.company.city) = $event)),
                  class: "form-control",
                  id: "city",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.company.city]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.contact.firstName) = $event)),
                  class: "form-control",
                  id: "first_name",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.contact.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.contact.lastName) = $event)),
                  class: "form-control",
                  id: "last_name",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.contact.lastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.contact.phone) = $event)),
                  class: "form-control",
                  id: "phone",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.contact.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.contact.email) = $event)),
                  class: "form-control",
                  id: "email",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.data.contact.email]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.billing.name) = $event)),
                  class: "form-control",
                  id: "companyName"
                }, null, 512), [
                  [_vModelText, _ctx.data.billing.name]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.billing.street) = $event)),
                  class: "form-control",
                  id: "street"
                }, null, 512), [
                  [_vModelText, _ctx.data.billing.street]
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.billing.streetNo) = $event)),
                  class: "form-control",
                  id: "street_no"
                }, null, 512), [
                  [_vModelText, _ctx.data.billing.streetNo]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.billing.addressAddition) = $event)),
                  class: "form-control",
                  id: "address_addition"
                }, null, 512), [
                  [_vModelText, _ctx.data.billing.addressAddition]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  type: "postal_code",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.data.billing.postalCode) = $event)),
                  class: "form-control",
                  id: "postal_code"
                }, null, 512), [
                  [_vModelText, _ctx.data.billing.postalCode]
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.data.billing.city) = $event)),
                  class: "form-control",
                  id: "city"
                }, null, 512), [
                  [_vModelText, _ctx.data.billing.city]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              (!_ctx.hasOrganisation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_55))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_router_link, { to: { name: 'company' } }, {
                  default: _withCtx(() => [
                    (_ctx.hasOrganisation)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_57, " Zurück "))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (!_ctx.hasOrganisation)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_58, " Jetzt Anlegen "))
                  : _createCommentVNode("", true),
                (_ctx.hasOrganisation)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_59, " Speichern "))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}